/* src/app/modules/employees/employees-list.component.css */
:host {
  --el-brand: #e3fd64;
  --el-brand-d: #4d7a00;
  --el-text: #1a1d23;
  --el-muted: #6b7280;
  --el-border: #e5e7eb;
  --el-surface: #ffffff;
  --el-radius: 10px;
  --el-shadow: 0 2px 8px rgba(0,0,0,0.07);
}
.el-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.el-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.el-page-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.el-page-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.el-page-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.el-page-header__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--el-text);
  line-height: 1.2;
}
.el-page-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--el-muted);
}
.el-page-header__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.el-filter-check {
  font-size: 13px;
}
.el-btn-sync {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #6b7280 !important;
  border-color: #e5e7eb !important;
}
.el-btn-sync mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}
.el-btn-add {
  background-color: var(--el-brand) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.el-btn-add mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}
.el-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 64px 24px;
}
.el-loading__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.12);
}
.el-loading__icon-wrap mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: var(--el-brand);
}
.el-loading__dots {
  display: flex;
  gap: 8px;
}
.el-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--el-brand);
  opacity: 0.3;
  animation: el-pulse 1.2s ease-in-out infinite;
}
.el-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.el-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.el-loading__text {
  margin: 0;
  font-size: 14px;
  color: var(--el-muted);
}
@keyframes el-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.el-table-wrap {
  background: var(--el-surface);
  border-radius: var(--el-radius);
  box-shadow: var(--el-shadow);
  border: 1px solid var(--el-border);
  overflow: hidden;
}
.el-tabs {
  border-radius: var(--el-radius);
  overflow: hidden;
}
::ng-deep .el-tabs .mat-mdc-tab-header {
  background: var(--el-surface);
  border-bottom: 1px solid var(--el-border);
}
::ng-deep .el-tabs .mat-mdc-tab-body-wrapper {
  padding-top: 16px;
}
.el-action-danger,
.el-action-danger mat-icon {
  color: #dc2626 !important;
}
.el-action-danger:hover {
  background: rgba(220, 38, 38, 0.05) !important;
}
.working-yes {
  color: #16a34a !important;
  font-weight: 600 !important;
}
.working-no {
  color: #dc2626 !important;
}
.ed-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 20px 20px 0;
  position: relative;
}
.ed-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(220, 38, 38, 0.1);
  flex-shrink: 0;
}
.ed-icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #dc2626;
}
.ed-title {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #1a1d23;
  line-height: 1.3 !important;
}
.ed-sub {
  margin: 3px 0 0;
  font-size: 12px;
  color: #6b7280;
}
.ed-close {
  position: absolute !important;
  top: 12px;
  right: 12px;
  color: #9ca3af !important;
}
.ed-content {
  padding: 16px 20px !important;
}
.ed-msg {
  margin: 0;
  font-size: 14px;
  color: #374151;
}
.ed-feedback {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 8px;
  background: rgba(22, 163, 74, 0.08);
  color: #166534;
  font-size: 13px;
  font-weight: 500;
}
.ed-feedback mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.ed-actions {
  padding: 8px 20px 20px !important;
  justify-content: flex-end !important;
  gap: 8px;
}
.ed-btn-delete {
  background-color: #dc2626 !important;
  color: #fff !important;
  font-weight: 500 !important;
}
/*# sourceMappingURL=employees-list.component.css.map */
